import type { UpdateUrl } from './hooks.js';

/**
 * 정렬 머리글에 매번 넘기던 세 인자를 한 번만 묶는다.
 *
 * 목록 화면들이 머리글마다 이렇게 적고 있었다 - 상품 관리에 4번, 주문 관리에
 * 9번, 모두 13번이다.
 *
 *   <SortableTh label="주문일" sortKey="orderDate"
 *     currentSort={sort} currentDir={dir}
 *     onSort={(k, d) => update({ sort: k, dir: d })} />
 *
 * 인자 세 개가 화면 안에서 언제나 같은 값이라 한 곳에서 묶어 준다. 호출부는
 * 아래처럼 남는다.
 *
 *   const th = useTableSort(sort, dir, update);
 *   <SortableTh label="주문일" sortKey="orderDate" {...th} />
 *
 * 훅이라 이름 붙였지만 React 상태를 쓰지 않는다 - 정렬 값의 출처는 URL 이고
 * (useUrlUpdate), 이 함수는 그것을 읽어 넘길 모양으로만 바꾼다. 상태를 새로
 * 만들지 않는 편이 URL 하나만 진실로 두는 기존 방식과 어긋나지 않는다.
 */
export function useTableSort(
  sort: string | undefined,
  dir: 'asc' | 'desc',
  update: UpdateUrl,
): {
  currentSort: string | undefined;
  currentDir: 'asc' | 'desc';
  onSort: (key: string, nextDir: 'asc' | 'desc') => void;
} {
  return {
    currentSort: sort,
    currentDir: dir,
    onSort: (key, nextDir) => update({ sort: key, dir: nextDir }),
  };
}
